import { render, staticRenderFns } from "./ButtonCopy.vue?vue&type=template&id=fddcd324"
import script from "./ButtonCopy.vue?vue&type=script&lang=js"
export * from "./ButtonCopy.vue?vue&type=script&lang=js"
import style0 from "./ButtonCopy.vue?vue&type=style&index=0&id=fddcd324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports